import { toast } from 'react-toastify';
import { useMutation } from '@tanstack/react-query';

export const useSendOTP = (sendOTPFn, onSuccessCallback) =>
  useMutation({
    mutationFn: ({ email, silent = false }) => sendOTPFn({ email }),
    onSuccess: (_, variables) => {
      const { email, silent } = variables;
      // Only show toast if not silent
      if (!silent) {
        toast.success(`OTP sent to ${email}`, {
          autoClose: 2000,
          className:
            'bg-[var(--yellow-primary)] text-black text-sm px-2 py-2 rounded-md',
          closeButton: false,
        });
      }

      if (onSuccessCallback) onSuccessCallback(email);
    },
    onError: (error) => {
      console.error('Error sending OTP:', error);
      const msg = error?.response?.data?.message || error?.message;
      toast.error(msg, {
        autoClose: 3000,
        className:
          'bg-[var(--yellow-primary)] text-black text-sm px-2 py-2 rounded-md',
        closeButton: false,
      });
    },
  });
